import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-no-templates',
  templateUrl: './no-templates.component.html',
  styleUrls: ['./no-templates.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoTemplatesComponent {
  noTemplateUrl = 'https://vstatic-prod.apigateway.co/wsp-portal-client.9223372035063561656.demo/assets/images/no-templates.svg';
}
